/*
 * @Author: 丨小小风离丨
 * @Date: 2024-01-03 16:28:34
 * @LastEditTime: 2025-06-25 15:23:33
 * @LastEditors: 丨小小风离丨
 * @FilePath: \web-school-enroll\src\router\pageRout.tsx
 * @Description: 
 */
import LoadingSpinner from '@/components/loadingSpinner';
import Contact from '@/page/contact';
import EnrollMessage from '@/page/enrollMessage';
import EnrollPlan from '@/page/enrollPlan';
import EnrollPlanDetails from '@/page/enrollPlan/details';
import Materials from '@/page/materials';
import MaterialsDetails from '@/page/materials/details';
import Information from '@/page/information';
import InformationDetails from '@/page/information/details';
import Teachins from '@/page/teachins';
import TeachinsDetails from '@/page/teachins/details';
import { Suspense } from 'react';
import { routeTs } from '../types/types';
import IntentRegistration from '@/page/intentRegistration';
import AdmissionInquiry from '@/page/admissionInquiry';

const pageRout: routeTs[] = [
    {
        path: '/information',
        name: '招生资讯',
        element: <Suspense fallback={<LoadingSpinner />}><Information /></Suspense>,
        isMenu: true,
        children: [
            {
                path: '/information/details',
                pathName: 'details',
                name: '招生资讯详情',
                desc: 'Enrollment Information Details',
                element: <Suspense fallback={<LoadingSpinner />}><InformationDetails /></Suspense>,
            }
        ]
    },
    {
        path: '/enrollPlan',
        name: '招生报名',
        element: <Suspense fallback={<LoadingSpinner />}>
            <EnrollPlan />
        </Suspense>,
        isMenu: true,
        children: [
            {
                path: '/enrollPlan/details',
                name: '招生计划详情',
                desc: 'Enrollment Plan Details',
                element: <Suspense fallback={<LoadingSpinner />}><EnrollPlanDetails /></Suspense>,
            }
        ]
    },
    {
        path: '/teachins',
        name: '宣讲会',
        element: <Suspense fallback={<LoadingSpinner />}>
            <Teachins />
        </Suspense>,
        isMenu: true,
        children: [
            {
                path: '/teachins/details',
                name: '宣讲会详情',
                desc: 'Teachins Details',
                element: <Suspense fallback={<LoadingSpinner />}><TeachinsDetails /></Suspense>,
            }
        ]
    },
    {
        path: '/materials',
        name: '历史招生数据',
        element: <Suspense fallback={<LoadingSpinner />}><Materials /></Suspense>,
        isMenu: true,
        children: [
            {
                path: '/materials/details',
                name: '历史招生数据详情',
                desc: '历史招生数据详情',
                element: <Suspense fallback={<LoadingSpinner />}><MaterialsDetails /></Suspense>,
            }
        ]
    },
    {
        path: '/enrollMessage',
        name: '留言板',
        element: <Suspense fallback={<LoadingSpinner />}><EnrollMessage /></Suspense>,
        isMenu: true
    },
    {
        path: '/intentRegistration',
        name: '意向报读登记',
        element: <Suspense fallback={<LoadingSpinner />}><IntentRegistration /></Suspense>,
        isMenu: true
    },
    {
        path: '/contact',
        name: '关于我们',
        element: <Suspense fallback={<LoadingSpinner />}><Contact /></Suspense>,
        isMenu: true
    },
    {
        path: '/admissionInquiry',
        name: '录取查询',
        element: <Suspense fallback={<LoadingSpinner />}><AdmissionInquiry /></Suspense>,
        isMenu: true
    }
]
export default pageRout
